.container {
  display: inline-flex;
  flex-shrink: 0;
  gap: 0.1875rem;
  align-items: center;

  margin-left: 0.375rem;

  vertical-align: middle;
}

.badgeWrapper {
  pointer-events: auto; // Force clickability even if parent container disables it
  cursor: pointer;

  position: relative;

  overflow: hidden;
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  // Circle clip lives here — cleaner antialiasing than on <img>
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50%;
  // Remove hardware acceleration hacks (translateZ) as they rasterize SVGs into blurry textures

  // Tooltip trigger
  &:hover {
    .tooltip {
      transform: translateX(-50%) translateY(0);
      visibility: visible;
      opacity: 1;
    }
  }
}

.badgeIcon {
  // Slight zoom (108%) to maximize visual clarity while keeping it crisp
  display: block;

  width: 108%;
  height: 108%;
  margin: -4%;

  object-fit: cover;

  // Force extreme high-quality vector rendering
  image-rendering: -webkit-optimize-contrast;
  image-rendering: high-quality;

  // Smooth transitions for hover effects
  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: scale(1.18);
  }
}

// Lightweight CSS-only premium tooltip using glassmorphism effects
.tooltip {
  pointer-events: none;

  position: absolute;
  z-index: 100;
  bottom: 140%;
  left: 50%;
  transform: translateX(-50%) translateY(4px);

  padding: 0.25rem 0.5rem;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 0.375rem;

  font-size: 0.6875rem;
  font-weight: 500;
  color: #fbfbfb;
  white-space: nowrap;

  visibility: hidden;

  // Transition state
  opacity: 0;

  // Premium dark-mode glassmorphic aesthetics
  background: rgba(18, 18, 18, 0.85);
  -webkit-backdrop-filter: blur(6px);
  backdrop-filter: blur(6px);

  // Drop shadow for a floating elevation effect
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);

  transition: opacity 0.18s ease-out, transform 0.18s ease-out, visibility 0.18s ease-out;
}

// Modal styling for badge details
.modalContent {
  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 1rem;

  color: var(--color-text);
  text-align: center;
}

.modalMessage {
  margin-bottom: 1.5rem;
  font-size: 1rem;
  line-height: 1.4;
  strong {
    color: var(--color-primary);
  }
}

.learnMoreContent {
  margin-top: 1rem;
  padding: 1.25rem;
  border-radius: 0.5rem;

  font-size: 0.875rem;
  line-height: 1.5;
  color: var(--color-text-secondary);
  text-align: left;

  background-color: var(--color-background-secondary);

  animation: fadeSlideDown 0.2s ease-out forwards;

  p {
    margin-bottom: 0.75rem;
    &:last-child {
      margin-bottom: 0;
    }
  }
  strong {
    color: var(--color-primary);
  }
}

@keyframes fadeSlideDown {
  from {
    transform: translateY(-8px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.mentionLink {
  cursor: pointer;
  font-weight: 500;
  color: var(--color-primary);
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}
